import {MaterialNode} from "#material/nodes/base/material/material-node"
import type {DisplacementSockets} from "#material/nodes/vector/displacement/definition"
import {displacementDefinition} from "#material/nodes/vector/displacement/definition"
import type {CyclesReturns} from "#material/sockets/cycles"
import {threeConvert, threeVec3} from "#material/three/three-utils"
import type {CyclesEvaluator, ThreeEvaluator} from "#material/nodes/base/material/types/evaluators"
import {registerMaterialGraphNode} from "#material/register"
import type {ThreeReturns} from "#material/sockets/three"
import type {Space} from "#material/nodes/vector/displacement/validation"
import {cyclesSpace} from "#material/nodes/vector/displacement/helpers"
import type {DisplacementNode} from "#material/cycles/types"
import {cyclesVec3} from "#material/cycles/helpers"

@registerMaterialGraphNode
export class Displacement extends MaterialNode<DisplacementSockets> {
    public override get definition() {
        return displacementDefinition
    }

    override toThree = async (evaluator: ThreeEvaluator): Promise<ThreeReturns<DisplacementSockets>> => {
        const {logger} = evaluator.context
        logger.warn("Displacement map node not implemented for THREE materials")
        return {
            displacement: threeConvert(this.parameters.settings.displacement, threeVec3) ?? threeVec3({x: 0, y: 0, z: 0}),
        }
    }

    override toCycles = async (evaluator: CyclesEvaluator): Promise<CyclesReturns<DisplacementSockets>> => {
        const displacementNode: DisplacementNode = {
            type: "displacement",
            inputs: await evaluator.getAll({
                height: this.parameters.inputs.height,
                midlevel: this.parameters.inputs.midlevel,
                normal: this.parameters.inputs.normal,
                scale: this.parameters.inputs.scale,
            }),
            parameters: {
                height: this.parameters.settings.height,
                midlevel: this.parameters.settings.midlevel,
                normal: cyclesVec3(this.parameters.settings.normal),
                scale: this.parameters.settings.scale,
                space: cyclesSpace(this.parameters.settings.space as Space | undefined),
            },
            resources: {},
        }

        return {displacement: [displacementNode, "displacement"]}
    }
}
